// Constants
export const styles = {
  card: {
    background: "white",
    margin: "0.5rem",
    borderRadius: 2,
    boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
    maxWidth: "300px",
    minWidth: "200px",
    width: "100%",
    height: "auto",
    display: "flex",
    flexDirection: "column",
  },
  cardFullName: {
    width: "100%",
    fontWeight: 600,
    fontSize: { xs: "0.9rem", sm: "1rem", md: "1.125rem" },
    lineHeight: 1.05,
    textAlign: "left",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};
